/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the mod and never type a command again. It just works.`)
};

const zh_hans1_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装 Mod 后即可享受丝滑体验，无需再输入繁琐的登录指令。`)
};

const zh_hant1_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝 Mod 後即可享受順暢體驗，無需再輸入繁瑣的登入指令。`)
};

const fr_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installez le mod et ne tapez plus jamais de commande. Ça marche, tout simplement.`)
};

const de_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mod installieren und nie wieder einen Befehl tippen. Es funktioniert einfach.`)
};

const ja_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOD を導入したら、もうコマンド入力は不要。すぐ動きます。`)
};

const ko_card_seamless_integration_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모드를 설치하면 더 이상 명령어를 입력할 필요가 없습니다. 그냥 작동합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_seamless_integration_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_seamless_integration_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_seamless_integration_desc", locale)
	if (locale === "en") return en_card_seamless_integration_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_seamless_integration_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_seamless_integration_desc(inputs)
	if (locale === "fr") return fr_card_seamless_integration_desc(inputs)
	if (locale === "de") return de_card_seamless_integration_desc(inputs)
	if (locale === "ja") return ja_card_seamless_integration_desc(inputs)
	return ko_card_seamless_integration_desc(inputs)
};